export default class TransformError {
  /**
   * 解析错误码，表示已经解析到末尾，没有可再解析的数据
   */
  static ALLREADY_TO_END = 'endError';
  /**
   *
   */
  static UNKOWN_CONDITION = 'unkownConditionError';

  code: string;
  msg: string;
  constructor(code: string, msg: string) {
    this.code = code;
    this.msg = msg;
  }
}
